module.exports = __webpack_public_path__ + "static/img/m_name.944b6ab.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/yjyx/m_name.png
// module id = siZZ
// module chunks = 7